import React from 'react'
import PropTypes from 'prop-types'

const ProjectionDisclaimer = ({ projectionDisclaimer }) => {
  if (!projectionDisclaimer) {
    return null
  }

  return (
    <div className='projection-disclaimer p-4 gap-4 flex flex-col md:block'>
      <small>
        { projectionDisclaimer.content }
      </small>
    </div>
  )
}

ProjectionDisclaimer.propTypes = {
  projectionDisclaimer: PropTypes.shape({
    content: PropTypes.string
  }).isRequired
}

export { ProjectionDisclaimer }
